import { render } from "./CalendarLessonInfo.vue?vue&type=template&id=34cccb54&scoped=true"
import script from "./CalendarLessonInfo.vue?vue&type=script&lang=js"
export * from "./CalendarLessonInfo.vue?vue&type=script&lang=js"

import "./CalendarLessonInfo.vue?vue&type=style&index=0&id=34cccb54&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34cccb54"]])

export default __exports__